import * as React from 'react';
import './index.scss';

interface Fact {
    text: string;
    href: string;
}

const factsList: Array<Fact> = [
    {
        text: 'Реєстрація ПРРО через Електронний кабінет платника податків',
        href: 'blog/article/1'
    },
    {
        text: 'Чи потрібне РРО за наявності банківської «ключ-картки» у ФОПа?',
        href: 'blog/article/3'
    },    
    {
        text: 'Переваги використання хмарної каси перед стаціонарними касовими апаратами',
        href: 'blog/article/8'
    }
];

const Facts: React.FC = () => (
    <section className="facts">
        <h2 className="header-normal facts__header">Корисно знати</h2>
        <p className="text-large facts__text">
            З 1 серпня 2020 року в Україні офіційно дозволено користуватися ПРРО: програмним реєстратором розрахункових операцій або ж онлайн касовим апаратом у смартфоні.
        </p>
        <h3 className="text-normal facts__list-header">Більш детально читайте за посиланнями:</h3>
        <ul className="facts__list">
            {factsList.map(item =>
                <li className="facts__item" key={item.text}>
                    <a
                        className="text-normal facts__list-text"
                        rel="noopener noreferrer"
                        target="_blank"
                        href={item.href}
                    >
                        {item.text}
                    </a>
                </li>
            )}
        </ul>
    </section>
);

export default Facts;
